<template>
  <div style="width:100%;height: 221px;position:relative;top:-62px;">
    <div class="legend-list">
      <div class="legend-item legendfist">
        <div class="square" style="background-color: #0c9be3;"></div>
        <span class="legendtext">待审核</span>
      </div>
      <div class="legend-item legendfive">
        <div class="square" style="background-color: #0fb9aa;"></div>
        <span class="legendtext">待打表</span>
      </div>
      <div class="legend-item legendsecode">
        <div class="square" style="background-color: #ffcc00;"></div>
        <span class="legendtext">公示中</span>
      </div>
      <div class="legend-item legendthid">
        <div class="square" style="background-color: #da2688;"></div>
        <span class="legendtext">待结算</span>
      </div>
      <div class="legend-item legendfourth">
        <div class="square" style="background-color: #6db90a;"></div>
        <span class="legendtext">已结算</span>
      </div>

    </div>
    <div id="barCirtenRegion" style="width:100%;height:100%;"></div>
  </div>
</template>

<script>
import Http from "../../Serves/net-http.js";
import Api from "../../Serves/net-api.js";
export default {
  name: 'RegionChart',
  data () {
    return {
      color: '#0c85e3',
      xData: [],
      yData: {}
    }
  },
  mounted () {
    // this.polyline();
    this.getWorkStatisticsData()
  },
  methods: {
    polyline () {
      this.RegionChart = this.$echarts.init(document.getElementById('barCirtenRegion'))
      this.RegionChart.setOption(
        {
          tooltip: {
            trigger: 'axis',
            textStyle: {
              align: 'left'
            }
          },
          grid: {
            top: '15%',
            left: '3%',
            right: '4%',
            bottom: '5%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            axisLine: {//坐标轴线
              lineStyle: {
                color: '#283b85',
                fontSize: '14'
              }
            },
            axisLabel: {
              interArrival: 0,
              // rotate: -30,
              textStyle: {
                color: '#fff',
                fontSize: 16
              }
            },
            data: this.xData,
            axisTick: { //去掉刻度线
              show: false
            }
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff',
                fontSize: '14'
              }
            },
            axisLabel: {
              interArrival: 0,
              textStyle: {
                color: '#fff',
                fontSize: 16
              }
            },
            splitLine: {
              lineStyle: {
                color: ['#283b85']
              }
            },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              name: '待审核',
              barWidth: 15, //柱图宽度
              type: 'bar',
              stack: '各地区补贴进度',
              data: this.yData.auditMoney,
              itemStyle: {
                normal: {
                  color: '#0c9be3'
                }
              }
            },
            {
              name: '待打表',
              barWidth: 15, //柱图宽度
              type: 'bar',
              stack: '各地区补贴进度',
              data: this.yData.toPrintMoney,
              itemStyle: {
                normal: {
                  color: '#0fb9aa'
                }
              }
            },
            {
              name: '公示中',
              barWidth: 15,
              type: 'bar',
              stack: '各地区补贴进度',
              data: this.yData.publicMoney,
              itemStyle: {
                normal: {
                  color: '#ffcc00'
                }
              }
            },
            {
              name: '待结算',
              barWidth: 15,
              type: 'bar',
              stack: '各地区补贴进度',
              data: this.yData.accountMoney,
              itemStyle: {
                normal: {
                  color: '#da2688'
                }
              }
            },
            {
              name: '已结算',
              barWidth: 15,
              type: 'bar',
              stack: '各地区补贴进度',
              data: this.yData.accountedMoney,
              itemStyle: {
                normal: {
                  color: '#6db90a'
                }
              }
            }
          ]
        })
      window.addEventListener('resize', () => { this.RegionChart.resize() })
    },
    getWorkStatisticsData () {
      Api.doPost(Http.workSubsidy.workStatistics, null, false, (res) => {
        let data = res.result
        let auditMoney = [], publicMoney = [], accountMoney = [], accountedMoney = [], toPrintMoney = []
        for (var i = 0; i < data.subsidesPlanList.length; i++) {
          this.xData.push(data.subsidesPlanList[i].name)
          auditMoney.push(data.subsidesPlanList[i].auditMoney)
          publicMoney.push(data.subsidesPlanList[i].publicMoney)
          accountMoney.push(data.subsidesPlanList[i].accountMoney)
          accountedMoney.push(data.subsidesPlanList[i].accountedMoney)
          toPrintMoney.push(data.subsidesPlanList[i].toPrintMoney)
        }
        this.yData.auditMoney = auditMoney
        this.yData.publicMoney = publicMoney
        this.yData.accountMoney = accountMoney
        this.yData.accountedMoney = accountedMoney
        this.yData.toPrintMoney = toPrintMoney
        this.polyline()
      })
    }
  }
}
</script>
<style scoped>
  .legend-list{
    display: flex;
    justify-content: center;
  }
  .legend-item{
    margin: 0 5px;
  }
  .legendfist{
    color: #0c9be3;
  }
  .legendsecode{
    color: #ffcc00;
  }
  .legendthid{
    color: #da2688;
  }
  .legendfive{
    color: #0fb9aa;
  }
  .legendfourth{
    color: #6db90a;
  }
  .legendtext{
    position: relative;
    bottom: 4px;
  }
  .square{
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-top: 20px;
  }
  .unit{
    margin-top: 5px;
    font-size: 14px;
    text-align: right;
	  color: #0c9be3;
  }
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/RegionChart.vue